module.exports = __webpack_public_path__ + "static/media/android.45b6f305.svg";